import { Injectable } from '@angular/core';
import { ICategoryBoxItem } from '../../columns/components/activity-box/activity-box.component';
import { BehaviorSubject, Observable, Subject, skip, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {
  private sideBarStatusSubject:BehaviorSubject<boolean> = new BehaviorSubject(true)
  private sideBarStatusObs:Observable<boolean> = this.sideBarStatusSubject.asObservable()
  sidebarStatus:boolean = true
  loading = false;
  muteClass={}
  categoryBoxItems:ICategoryBoxItem[]=[
    {
      name:'آزمون‌ها',
      routerLink:'exam',
      is_show:false,
    }
  ]
  sidebarClass={'rtl:translate-x-full' : this.sidebarStatus,'ltr:-translate-x-full': this.sidebarStatus , 'hidden':this.sidebarStatus}
  abzarStatus = {
    category:false,
    activity:false,
  }
  is_exist_activity:boolean = false;
  mizMoreColItem:any = {advanceSearch:false,reportShowItem:false};
  requiredType:any;
  reportTypeListData:any;
  private reportCardUserFLowBarStatusSub:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  reportCardUserFlowBarStatusObs$ = this.reportCardUserFLowBarStatusSub.asObservable().pipe(
  )
  private canOrderingFilterInReportItemStatusSub:BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  canOrderingFilterInReportItemStatusObs$ = this.reportCardUserFLowBarStatusSub.asObservable().pipe(
  )
  retunPathEntityFlow:any = null
  constructor(){}
  getSideBarStatusObs():Observable<boolean>{
    return this.sideBarStatusObs
  }
  changeSidebarState(){
    this.sideBarStatusSubject.next(!this.sideBarStatusSubject.value)
    this.sidebarStatus = !this.sidebarStatus
    this.sidebarClass={'rtl:translate-x-full' : true,'ltr:-translate-x-full': true,'hidden':false}
    setTimeout(() => {
      this.sidebarClass={'rtl:translate-x-full' : this.sidebarStatus,'ltr:-translate-x-full': this.sidebarStatus,'hidden':this.sidebarStatus}
    }, 300);
    this.sidebarStatus?  setTimeout(() => {this.muteClass ={'hidden':this.sidebarStatus}}, 300) : this.muteClass ={'hidden':this.sidebarStatus}
  }
  setCanOrderingFilterInReportItemStatus(bool:any){
    this.canOrderingFilterInReportItemStatusSub.next(bool)
  }
  getCanOrderingFilterInReportItemStatus(){
    return this.canOrderingFilterInReportItemStatusObs$
  }
  closeSidebarState(){
    this.sideBarStatusSubject.next(true)
    this.sidebarStatus = true
  }
  columnItemSub:BehaviorSubject<any> = new BehaviorSubject(null);
  columnItemObs:Observable<any> = this.columnItemSub.asObservable().pipe(
  );
  setColumnItem(name:string,status:boolean):void{
    this.columnItemSub.next({...this.mizMoreColItem,[name as string]:status})
  }
  getColumnItemObs():Observable<any>{
    return this.columnItemObs
  }
  resetColumnSub(){
    this.columnItemSub.next(null)
  }
  setFlowBarStatus(bool:boolean){
    this.reportCardUserFLowBarStatusSub.next(bool)
  }
  getFlowBarObs$():Observable<boolean>{
    return this.reportCardUserFlowBarStatusObs$
  }
  setTypeOfRequired(requiredTypeObj:any){
    this.requiredType = requiredTypeObj
  }
  getTypeOfRequired(){
      return this.requiredType
  }
  setReportItem(list:any){
    this.reportTypeListData = list
  }
  getReportItem(){
    return this.reportTypeListData
  }
}